'use client';
import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';

const DATA = [
  { name: 'Bilingual (EN + EL)', value: 412, color: '#1a2e5a' },
  { name: 'English Only', value: 284, color: '#c9a84c' },
  { name: 'Greek Only', value: 151, color: '#8892a8' },
];

const CustomTooltip = ({ active, payload }: { active?: boolean; payload?: { name: string; value: number; payload: { color: string } }[] }) => {
  if (!active || !payload?.[0]) return null;
  const total = DATA.reduce((s, d) => s + d.value, 0);
  const pct = Math.round((payload[0].value / total) * 100);
  return (
    <div className="bg-white border border-[#e2e6f0] rounded-xl shadow-lg p-3 text-xs">
      <p className="font-700 text-[#0f1a35] mb-1">{payload[0].name}</p>
      <p className="text-[#4a5578]">Count: <span className="font-700 text-[#1a2e5a]">{payload[0].value}</span></p>
      <p className="text-[#4a5578]">Share: <span className="font-700 text-[#1a2e5a]">{pct}%</span></p>
    </div>
  );
};

const CustomLegend = () => {
  const total = DATA.reduce((s, d) => s + d.value, 0);
  return (
    <div className="flex flex-col gap-2 mt-3">
      {DATA.map((entry) => {
        const pct = Math.round((entry.value / total) * 100);
        return (
          <div key={`lang-legend-${entry.name}`} className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-sm flex-shrink-0" style={{ backgroundColor: entry.color }} />
            <span className="text-xs text-[#4a5578] flex-1 min-w-0 truncate">{entry.name}</span>
            <span className="text-xs font-700 text-[#0f1a35] tabular-nums">{entry.value}</span>
            <span className="text-xs text-[#8892a8] tabular-nums w-8 text-right">{pct}%</span>
          </div>
        );
      })}
    </div>
  );
};

export default function SubmissionsByLanguageChart() {
  return (
    <div>
      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie
            data={DATA}
            cx="50%"
            cy="50%"
            innerRadius={55}
            outerRadius={85}
            paddingAngle={3}
            dataKey="value"
          >
            {DATA.map((entry, i) => (
              <Cell key={`lang-cell-${i}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      <CustomLegend />
    </div>
  );
}